import script from "./scrapDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./scrapDetails.vue?vue&type=script&setup=true&lang=ts"

import "./scrapDetails.vue?vue&type=style&index=0&id=d3755270&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3755270"]])

export default __exports__